import { configureStore } from '@reduxjs/toolkit'
import authReducer from './user/authSlice.ts'
import storage from 'redux-persist/lib/storage'
import { combineReducers } from 'redux'
import { persistReducer, persistStore } from 'redux-persist'
import userReducer from '@/storage/user/userSlice.ts'
import programsReducer from '@/storage/programs/slice.ts'
import taskReducer from '@/storage/tasks/slice.ts'
import { FLUSH, REHYDRATE, PAUSE, PERSIST, REGISTER } from 'redux-persist'

const persistConfig = {
  key: 'root',
  storage,
  whitelist: ['user', 'auth', 'programs', 'tasks'],
}

const rootReducer = combineReducers({
  auth: authReducer,
  user: userReducer,
  programs: programsReducer,
  tasks: taskReducer,
})

const persistedReducer = persistReducer(persistConfig, rootReducer)

export const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        // Ignore non-serializable values in actions related to redux-persist
        ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, REGISTER],
      },
    }),
})

export const persistor = persistStore(store)

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>
// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
export type AppDispatch = typeof store.dispatch
